import * as ReactDom from 'react-dom';
import * as React from 'react';
import { UserAvatar } from './user-avatar/user-avatar';
import { GroupAvatar } from './group-avatar/group-avatar';
// tslint:disable-next-line:max-line-length
export var renderUserAvatarAndReturnUnmount = function (elem, user, size, isAgent) {
    var compProps = { user: user, size: size, isAgent: isAgent };
    ReactDom.render(React.createElement(UserAvatar, compProps), elem);
    return function () {
        ReactDom.unmountComponentAtNode(elem);
    };
};
export var renderGroupAvatarAndReturnUnmount = function (elem, group, size) {
    var compProps = { group: group, size: size };
    ReactDom.render(React.createElement(GroupAvatar, compProps), elem);
    return function () {
        ReactDom.unmountComponentAtNode(elem);
    };
};
//# sourceMappingURL=renderer.js.map